(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initContactSection = (root) => {
      if (!root || root.dataset.contactReady === 'true') return;
      root.dataset.contactReady = 'true';
      const form = root.querySelector('form');
      const consent = root.querySelector('[data-contact-consent]');
      const consentError = root.querySelector('[data-contact-consent-error]');
      const clientErrors = root.querySelector('[data-contact-client-errors]');
      const submitButton = form ? form.querySelector('[type="submit"]') : null;
      const success = root.querySelector('[data-contact-success]');
      const errors = root.querySelector('[data-contact-errors]');

      if (success) success.focus();
      if (errors) errors.focus();
      if (!form || !consent || !consentError) return;

      const clearConsentError = () => {
        consent.removeAttribute('aria-invalid');
        consentError.hidden = true;
      };

      const showConsentError = () => {
        consent.setAttribute('aria-invalid', 'true');
        consentError.hidden = false;
      };

      consent.addEventListener('change', () => {
        if (consent.checked) clearConsentError();
      });
      form.addEventListener('invalid', (event) => {
        event.target.setAttribute('aria-invalid', 'true');
        if (event.target === consent) showConsentError();
      }, true);

      form.querySelectorAll('input, select, textarea').forEach((field) => {
        const clearFieldError = () => {
          if (field.validity.valid) field.removeAttribute('aria-invalid');
          if (field === consent && consent.checked) clearConsentError();
          if (clientErrors) {
            const allValid = Array.from(form.elements).every((element) => !element.willValidate || element.validity.valid);
            if (allValid) clientErrors.hidden = true;
          }
        };
        field.addEventListener('input', clearFieldError);
        field.addEventListener('change', clearFieldError);
      });

      if (submitButton) {
        submitButton.addEventListener('click', (event) => {
          if (form.checkValidity()) return;
          event.preventDefault();
          if (clientErrors) clientErrors.hidden = false;
          const firstInvalid = form.querySelector(':invalid');
          if (!firstInvalid) return;
          if (firstInvalid === consent) showConsentError();
          firstInvalid.focus({ preventScroll: true });
          const target = firstInvalid.closest('.cp__field, .cp__consent-row') || firstInvalid;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    };

    document.querySelectorAll('[data-contact-premium]').forEach(initContactSection);
    document.addEventListener('shopify:section:load', (event) => {
      initContactSection(event.target.querySelector('[data-contact-premium]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isCartTemplate = document.body.classList.contains('template-cart') || /^\/cart\/?$/.test(window.location.pathname);
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      if (this.isCartTemplate) {
        window.addEventListener('resize', this.onResizeHandler, false);
      }

      this.createObserver();
      this.onScroll();
      this.setCartHeaderOffset();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onResize() {
      this.setCartHeaderOffset();
    }

    setCartHeaderOffset() {
      if (!this.isCartTemplate || !this.header) return;
      const headerHeight = this.header.offsetHeight || 0;
      if (headerHeight > 0) {
        document.documentElement.style.setProperty('--tapanda-cart-header-offset', `${headerHeight}px`);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.isCartTemplate) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.setCartHeaderOffset();
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.recommendationsObserver = null;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      if (!this.dataset.url) {
        this.dataset.loaded = 'true';
        this.callFunction();
        return;
      }

      if ('IntersectionObserver' in window) {
        this.recommendationsObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.recommendationsObserver.disconnect();
          this.recommendationsObserver = null;
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 280px 0px' });
        this.recommendationsObserver.observe(this);
        return;
      }

      this.loadRecommendations();
    }

    disconnectedCallback() {
      if (!this.recommendationsObserver) return;
      this.recommendationsObserver.disconnect();
      this.recommendationsObserver = null;
    }

    loadRecommendations() {
      if (!this.isConnected || this.dataset.loaded === 'true' || this.dataset.loaded === 'loading') return;
      this.dataset.loaded = 'loading';

      fetch(this.dataset.url)
          .then(response => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then(text => {
            if (!this.isConnected) return;
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              if (window.jQuery) {
                window.jQuery('.loading-image').removeClass('loading-image').addClass('loaded-image');
              } else {
                this.querySelectorAll('.loading-image').forEach((element) => {
                  element.classList.remove('loading-image');
                  element.classList.add('loaded-image');
                });
              }
            }

            if (html.querySelector('.swiper-slide')) {
              this.classList.add('product-recommendations--loaded');
            }
            this.dataset.loaded = 'true';
            this.callFunction();
          })
          .catch(() => {
            this.dataset.loaded = 'false';
          });
    }

    callFunction() {
      if (typeof DTWishlist === 'function') DTWishlist();
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapanda-stats-bar-v1"]) return;
  try {
    
  (() => {
    const rootSelector = '[data-tpstats-root]';
    const valueSelector = '[data-tpstats-value]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setFinalValue = (node) => {
      node.textContent = `${node.dataset.target || '0'}${node.dataset.suffix || ''}`;
    };

    const animateRoot = (root) => {
      if (root.dataset.tpstatsAnimated === 'true') return;
      root.dataset.tpstatsAnimated = 'true';

      const values = [...root.querySelectorAll(valueSelector)];
      if (reducedMotion.matches) {
        values.forEach(setFinalValue);
        return;
      }

      /* 25.07: licznik odliczał od zera, więc po drodze pokazywał NIEPRAWDZIWE
         dane — „6h średni czas wysyłki", „384+ zamówień", „0 sek". Zamiast
         liczyć, wartości pojawiają się od razu poprawne, a efekt daje
         delikatne wejście (klasa is-complete + animacja w CSS). */
      values.forEach((node, index) => {
        setFinalValue(node);
        node.style.animationDelay = (index * 90) + 'ms';
        node.classList.add('is-complete');
      });
    };

    const initializeRoot = (root) => {
      if (root.dataset.tpstatsInitialized === 'true') return;
      root.dataset.tpstatsInitialized = 'true';

      if (!('IntersectionObserver' in window)) {
        animateRoot(root);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        animateRoot(root);
      }, { threshold: 0.3 });

      observer.observe(root);
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.(rootSelector)) initializeRoot(scope);
      scope.querySelectorAll(rootSelector).forEach(initializeRoot);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapanda-value-bar-v2"]) return;
  try {
    
  (() => {
    const valueBar = document.querySelector('[data-tpvb-root]');
    if (!valueBar) return;

    const formatCount = (count) => {
      const value = Number(count);
      if (value === 1) return '1 opinia';
      const lastTwo = value % 100;
      const last = value % 10;
      if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return `${value} opinie`;
      return `${value} opinii`;
    };

    if (typeof window.tapandaStartJudgeSummarySync !== 'function') {
      window.tapandaStartJudgeSummarySync = () => {
        if (window.tapandaJudgeSummaryTimer) return;

        let attempts = 0;
        const readJudgeSummary = () => {
          const aggregateSource = document.querySelector(
            '.jdgm-all-reviews-text__text[data-score][data-number-of-reviews]'
          );
          const textSource = document.querySelector('.jdgm-average-rating .jdgm-rating-text');

          let ratingValue = aggregateSource?.dataset.score || '';
          let countValue = aggregateSource?.dataset.numberOfReviews || '';

          if ((!ratingValue || !countValue) && textSource) {
            const ratingMatch = textSource.textContent.match(/\d+(?:[.,]\d+)?/);
            const countNode = textSource.querySelector('.jdgm-reviews-count');
            ratingValue = ratingValue || ratingMatch?.[0] || '';
            countValue = countValue || countNode?.textContent || '';
          }

          const numericRating = Number.parseFloat(String(ratingValue).replace(',', '.'));
          const count = Number.parseInt(String(countValue).replace(/\D/g, ''), 10);
          if (!Number.isFinite(numericRating) || !Number.isFinite(count)) return false;

          const rating = numericRating.toFixed(2).replace('.', ',');

          const detail = {
            rating: `${rating}/5.00`,
            count,
            countLabel: formatCount(count)
          };

          window.tapandaJudgeSummary = detail;
          window.dispatchEvent(new CustomEvent('tapanda:judge-summary', { detail }));
          return true;
        };

        if (readJudgeSummary()) return;

        window.tapandaJudgeSummaryTimer = window.setInterval(() => {
          attempts += 1;
          if (readJudgeSummary() || attempts >= 50) {
            window.clearInterval(window.tapandaJudgeSummaryTimer);
            window.tapandaJudgeSummaryTimer = null;
          }
        }, 200);
      };
    }

    const applySummary = (detail) => {
      document.querySelectorAll('[data-tpvb-root]').forEach((root) => {
        const rating = root.querySelector('[data-tpvb-rating-value]');
        const count = root.querySelector('[data-tpvb-rating-count]');
        const link = root.querySelector('[data-tpvb-rating-link]');
        if (rating) {
          rating.textContent = detail.rating;
          rating.hidden = false;
        }
        if (count) count.textContent = detail.countLabel;
        if (link) link.setAttribute('aria-label', `${detail.rating} — ${detail.countLabel}`);
      });
    };

    window.addEventListener('tapanda:judge-summary', (event) => applySummary(event.detail));
    if (window.tapandaJudgeSummary) applySummary(window.tapandaJudgeSummary);
    window.tapandaStartJudgeSummarySync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-craft-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.tphrReady === 'true') return;
      root.dataset.tphrReady = 'true';

      const video = root.querySelector('[data-tphr-video]');
      if (!video) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = window.matchMedia('(max-width: 749px)');
      let isInView = false;
      let isPrepared = false;
      let playWhenReady = false;

      const sourceFor = () => {
        if (mobileViewport.matches) {
          return video.dataset.tphrVideoMobileSrc || video.dataset.tphrVideoDesktopSrc || '';
        }
        return video.dataset.tphrVideoDesktopSrc || video.dataset.tphrVideoMobileSrc || '';
      };

      const prepareVideo = () => {
        if (isPrepared) return;
        const source = sourceFor();
        if (!source) return;
        isPrepared = true;
        video.preload = 'auto';
        video.src = source;
        video.load();
      };

      const updateState = () => {
        const isPlaying = !video.paused && !video.ended;
        root.classList.toggle('is-playing', isPlaying);
      };

      const startPlayback = () => {
        playWhenReady = false;
        if (reducedMotion.matches || !isInView || document.hidden) return;
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(updateState);
        }
      };

      const playVideo = () => {
        if (reducedMotion.matches || !isInView || document.hidden) return;
        prepareVideo();
        if (video.readyState >= 3) {
          startPlayback();
          return;
        }
        if (!playWhenReady) {
          playWhenReady = true;
          video.addEventListener('canplay', startPlayback, { once: true });
        }
      };

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.pause();
      updateState();

      video.addEventListener('playing', updateState);
      video.addEventListener('pause', updateState);
      video.addEventListener('ended', updateState);

      if (!reducedMotion.matches && 'IntersectionObserver' in window) {
        const warmObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            prepareVideo();
            warmObserver.unobserve(entry.target);
          });
        }, { rootMargin: '1800px 0px', threshold: 0 });

        const playObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              isInView = true;
              playVideo();
            } else if (!entry.isIntersecting) {
              isInView = false;
              video.pause();
            }
          });
        }, { threshold: [0, 0.2, 0.55] });

        warmObserver.observe(root);
        playObserver.observe(root);
      } else if (!reducedMotion.matches) {
        isInView = true;
        prepareVideo();
        playVideo();
      }

      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) {
          video.pause();
        } else {
          const rect = root.getBoundingClientRect();
          isInView = rect.bottom > 0 && rect.top < window.innerHeight;
          if (isInView) prepareVideo();
          playVideo();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          video.pause();
        } else {
          playVideo();
        }
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-tphr-craft]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-faq-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-tphr-faq-list]:not([data-tphr-faq-ready])').forEach((list) => {
        const questions = list.closest('.tphr-faq__questions');
        const toggle = questions ? questions.querySelector('[data-tphr-faq-toggle]') : null;
        const extras = Array.from(list.querySelectorAll('[data-tphr-faq-extra]'));
        if (!toggle || extras.length === 0) return;

        list.setAttribute('data-tphr-faq-ready', 'true');
        const label = toggle.querySelector('[data-tphr-faq-toggle-label]');

        const setExpanded = (expanded) => {
          extras.forEach((item) => {
            if (!expanded) item.open = false;
            item.hidden = !expanded;
          });
          toggle.setAttribute('aria-expanded', String(expanded));
          if (label) label.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
        };

        toggle.addEventListener('click', () => {
          setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
        });

        extras.forEach((item) => {
          item.addEventListener('shopify:block:select', () => setExpanded(true));
        });

        setExpanded(false);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-gift-paths-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tphr-paths3]';

    const initialize = (scope = document) => {
      scope.querySelectorAll(`${selector}:not([data-tphr-paths3-ready])`).forEach((root) => {
        const track = root.querySelector('[data-tphr-paths3-track]');
        const slide = root.querySelector('[data-tphr-paths3-slide]');
        const previous = root.querySelector('[data-tphr-paths3-previous]');
        const next = root.querySelector('[data-tphr-paths3-next]');
        const controls = root.querySelector('[data-tphr-paths3-controls]');

        if (!track || !slide || !previous || !next || !controls) return;
        root.dataset.tphrPaths3Ready = 'true';

        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const scrollable = maximum > 4;
          controls.hidden = !scrollable;
          previous.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= maximum - 4;
        };

        const move = (direction) => {
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = slide.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: direction * distance, behavior: reduceMotion ? 'auto' : 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        track.addEventListener('focusin', (event) => {
          const focusedSlide = event.target.closest('[data-tphr-paths3-slide]');
          if (!focusedSlide || !track.contains(focusedSlide)) return;

          window.requestAnimationFrame(() => {
            const trackRect = track.getBoundingClientRect();
            const slideRect = focusedSlide.getBoundingClientRect();
            if (slideRect.left >= trackRect.left && slideRect.right <= trackRect.right) return;

            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const targetLeft = track.scrollLeft + slideRect.left - trackRect.left;
            track.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(track);
          root.tphrPaths3Observer = observer;
        } else {
          window.addEventListener('resize', update, { passive: true });
        }

        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-hero-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('.tphr-hero__main-video:not([data-tphr-video-ready])').forEach((video) => {
      video.setAttribute('data-tphr-video-ready', 'true');
      video.muted = true;
      video.playsInline = true;

      const frame = video.closest('.tphr-hero__media-frame');
      video.addEventListener('playing', () => {
        if (frame) frame.classList.add('tphr-hero__media-frame--video-playing');
      }, { once: true });

      if (reducedMotion.matches) {
        video.pause();
        return;
      }

      let playbackAllowed = false;
      let isVisible = false;

      const tryPlay = () => {
        if (!playbackAllowed || !isVisible) return;
        video.play().catch(() => {});
      };

      const allowPlayback = () => {
        if (playbackAllowed) return;
        playbackAllowed = true;
        tryPlay();
      };

      if (document.readyState === 'complete') {
        allowPlayback();
      } else {
        window.addEventListener('load', allowPlayback, { once: true });
        window.setTimeout(allowPlayback, 1800);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.18 });

      observer.observe(video);
    });

    const reviewLabel = (count) => {
      if (count === 1) return '1 opinia';
      const lastTwo = count % 100;
      const last = count % 10;
      if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return `${count} opinie`;
      return `${count} opinii`;
    };

    const applySummary = (detail) => {
      document.querySelectorAll('[data-tphr-judge-rating]').forEach((root) => {
        const value = root.querySelector('[data-tphr-rating-value]');
        const label = root.querySelector('[data-tphr-rating-label]');
        const labelText = reviewLabel(detail.count);
        if (value) {
          value.textContent = detail.rating;
          value.hidden = false;
        }
        if (label) label.textContent = labelText;
        root.setAttribute('aria-label', `${detail.rating} — ${labelText}`);
      });
    };

    window.addEventListener('tapanda:judge-summary', (event) => applySummary(event.detail));
    if (window.tapandaJudgeSummary) applySummary(window.tapandaJudgeSummary);

    let attempts = 0;
    const startSync = () => {
      attempts += 1;
      if (typeof window.tapandaStartJudgeSummarySync === 'function') {
        window.tapandaStartJudgeSummarySync();
      } else if (attempts < 30) {
        window.setTimeout(startSync, 100);
      }
    };
    startSync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-products-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tp-products-v3]';

    const initialize = (scope = document) => {
      scope.querySelectorAll(`${selector}:not([data-tp-products-ready])`).forEach((root) => {
        const track = root.querySelector('[data-tp-products-track]');
        const previous = root.querySelector('[data-tp-products-prev]');
        const next = root.querySelector('[data-tp-products-next]');
        const slide = root.querySelector('[data-tp-products-slide]');
        const viewport = root.querySelector('[data-tp-products-viewport]');
        const progressTrack = root.querySelector('[data-tp-products-progress-track]');
        const progressThumb = root.querySelector('[data-tp-products-progress]');

        if (!track || !previous || !next || !slide) return;

        root.dataset.tpProductsReady = 'true';

        // ── Zapętlenie: klon zestawu slajdów daje ciągły ruch bez skoku „w tył" ──
        // (ten sam wzorzec co karuzela realizacji). Klony są niewidoczne dla
        // czytników ekranu i wyłączone z nawigacji klawiaturą.
        const originalSlides = [...track.children];
        let loopWidth = 0;
        const canLoop = originalSlides.length >= 3;

        if (canLoop && !track.dataset.tpProductsCloned) {
          track.dataset.tpProductsCloned = 'true';
          originalSlides.forEach((original) => {
            const clone = original.cloneNode(true);
            clone.dataset.tpProductsClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
            track.appendChild(clone);
          });
        }

        const measureLoop = () => {
          if (!canLoop) { loopWidth = 0; return; }
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          loopWidth = originalSlides.reduce((sum, el) => sum + el.getBoundingClientRect().width + gap, 0);
        };

        const normalize = () => {
          if (!loopWidth) return;
          if (track.scrollLeft >= loopWidth) track.scrollLeft -= loopWidth;
          else if (track.scrollLeft < 0) track.scrollLeft += loopWidth;
        };

        // ── Wskaźniki karuzeli ──
        // Strzałki mają stać w połowie wysokości KADRU, nie karty — wysokość
        // kadru wynika z szerokości kolumny (aspect-ratio), więc w czystym CSS
        // policzyć się jej nie da. Mierzymy tylko przy zmianie szerokości toru.
        let measuredWidth = -1;

        const syncArrows = () => {
          if (!viewport) return;
          const width = track.clientWidth;
          if (width === measuredWidth) return;
          // 25.07: strzałki wyśrodkowane względem CAŁEJ karty, nie samego kadru
          // zdjęcia — wcześniej siadały na wysokości środka fotografii, czyli
          // wyraźnie powyżej połowy kafelka.
          const karta = track.querySelector('.tp-products-v3__card');
          if (!karta) return;
          const box = karta.getBoundingClientRect();
          if (!box.height) return;
          measuredWidth = width;
          const center = box.top - viewport.getBoundingClientRect().top + box.height / 2;
          root.style.setProperty('--tpc-arrow-top', `${Math.round(center)}px`);
        };

        // Pasek postępu: kciuk = jedna karta z zestawu, pozycja = ułamek
        // przewinięcia jednego zestawu (modulo loopWidth) — poprawny także
        // wtedy, gdy tor stoi na klonach.
        const paintRail = (maximum, scrollable) => {
          if (progressTrack) progressTrack.hidden = !scrollable;
          if (!progressThumb) return;
          let portion = 1;
          let ratio = 0;
          if (loopWidth > 0) {
            portion = 1 / Math.max(1, originalSlides.length);
            ratio = (track.scrollLeft % loopWidth) / loopWidth;
            if (ratio < 0) ratio += 1;
          } else if (maximum > 4) {
            portion = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
            ratio = Math.min(1, Math.max(0, track.scrollLeft / maximum));
          }
          progressThumb.style.width = `${(portion * 100).toFixed(2)}%`;
          progressThumb.style.left = `${(ratio * (1 - portion) * 100).toFixed(2)}%`;
        };

        const update = () => {
          measureLoop();
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const scrollable = maximum > 4;
          previous.hidden = !scrollable;
          next.hidden = !scrollable;
          if (loopWidth) {
            previous.disabled = false;
            next.disabled = false;
          } else {
            previous.disabled = track.scrollLeft <= 4;
            next.disabled = track.scrollLeft >= maximum - 4;
          }

          syncArrows();
          paintRail(maximum, scrollable);
        };

        // Własna animacja zamiast scrollBy({behavior:'smooth'}): przy scroll-snap
        // mandatory natywny smooth potrafi zatrzymać się po kilku pikselach.
        // Na czas przewijania snap jest wyłączany i przywracany po dojechaniu.
        let animationFrame = 0;
        let animationWatchdog = 0;

        const animateTo = (target, duration) => {
          window.cancelAnimationFrame(animationFrame);
          window.clearTimeout(animationWatchdog);
          const start = track.scrollLeft;
          const delta = target - start;
          if (!delta) return;

          const finish = () => {
            window.cancelAnimationFrame(animationFrame);
            window.clearTimeout(animationWatchdog);
            track.scrollLeft = target;
            normalize();
            track.style.scrollSnapType = '';
          };

          // Ukryta karta nie renderuje klatek (rAF stoi) — przeskakujemy od razu.
          if (document.hidden) { finish(); return; }

          track.style.scrollSnapType = 'none';
          const startedAt = performance.now();
          const step = (now) => {
            const progress = Math.min(1, (now - startedAt) / duration);
            const eased = 1 - Math.pow(1 - progress, 3);
            track.scrollLeft = start + delta * eased;
            if (progress < 1) animationFrame = window.requestAnimationFrame(step);
            else finish();
          };
          animationFrame = window.requestAnimationFrame(step);
          // Bezpiecznik: gdy karta zniknie w trakcie animacji, snap i tak wróci.
          animationWatchdog = window.setTimeout(finish, duration + 400);
        };

        const move = (direction) => {
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = slide.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // W pętli cofanie z pozycji 0 wymaga wcześniejszego przeskoku na koniec
          // klonów, inaczej ruch uderza w krawędź i nic się nie dzieje.
          if (loopWidth && direction < 0 && track.scrollLeft < distance) {
            track.style.scrollSnapType = 'none';
            track.scrollLeft += loopWidth;
          }
          const target = track.scrollLeft + direction * distance;
          if (reduceMotion) {
            track.scrollLeft = target;
            normalize();
            return;
          }
          animateTo(target, 620);
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(track);
          root.tpProductsObserver = observer;
        } else {
          window.addEventListener('resize', update, { passive: true });
        }

        update();

        // ── Kaskadowe wejście kart przy pierwszym wjeździe sekcji w kadr.
        //    Animacja siedzi w CSS pod [data-tp-inview]; bez atrybutu karty są
        //    widoczne od razu, więc awaria JS nie może ich ukryć.
        if ('IntersectionObserver' in window) {
          const revealObserver = new IntersectionObserver((entries, observer) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            root.setAttribute('data-tp-inview', '');
            observer.disconnect();
          }, { threshold: 0.12 });
          revealObserver.observe(viewport || root);
        } else {
          root.setAttribute('data-tp-inview', '');
        }

        // ── Autoodtwarzanie karuzeli: dryf o jedną kartę co 4 s ──
        // Pauzuje przy hoverze/fokusie/dotyku, po ręcznej interakcji odczekuje 9 s,
        // działa tylko gdy sekcja w kadrze i karta przeglądarki widoczna,
        // wraca płynnie na początek po ostatniej karcie. Reduced-motion = brak autoplay.
        const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!reduceMotionQuery.matches) {
          let paused = false;
          let inView = false;
          let resumeAt = 0;

          const advance = () => {
            if (paused || !inView || document.hidden) return;
            if (Date.now() < resumeAt) return;
            const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
            if (maximum <= 4) return;
            if (loopWidth) {
              move(1);
            } else if (track.scrollLeft >= maximum - 4) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              move(1);
            }
          };

          const autoplayId = window.setInterval(advance, 3500);
          root.tpProductsAutoplay = autoplayId;

          const holdOff = () => { resumeAt = Date.now() + 9000; };
          // Pauza TYLKO nad kartami — wcześniej łapała całą sekcję (~960px
          // wysokości), więc kursor leżący gdziekolwiek w niej zatrzymywał ruch.
          const hoverZone = root.querySelector('[data-tp-products-viewport]') || track;
          hoverZone.addEventListener('pointerenter', () => { paused = true; });
          hoverZone.addEventListener('pointerleave', () => { paused = false; holdOff(); });
          hoverZone.addEventListener('focusin', () => { paused = true; });
          hoverZone.addEventListener('focusout', () => { paused = false; holdOff(); });
          track.addEventListener('pointerdown', holdOff, { passive: true });
          previous.addEventListener('click', holdOff);
          next.addEventListener('click', holdOff);

          if ('IntersectionObserver' in window) {
            const viewObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => { inView = entry.isIntersecting; });
            }, { threshold: 0.35 });
            viewObserver.observe(root);
          } else {
            inView = true;
          }

          document.addEventListener('shopify:section:unload', (event) => {
            if (event.target === root || root.contains(event.target)) window.clearInterval(autoplayId);
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialize();
      }, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-home-video-banner-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const videos = document.querySelectorAll('[data-tphr-video-banner]:not([data-tphr-video-banner-ready])');
    if (!videos.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    const sourceFor = (video) => {
      if (mobileViewport.matches) {
        return video.dataset.tphrVideoMobileSrc || video.dataset.tphrVideoDesktopSrc || '';
      }
      return video.dataset.tphrVideoDesktopSrc || video.dataset.tphrVideoMobileSrc || '';
    };
    const hydrate = (video) => {
      const source = sourceFor(video);
      if (!source || video.dataset.tphrHydratedSource === source) return;
      video.dataset.tphrHydratedSource = source;
      video.preload = 'auto';
      video.src = source;
      video.load();
    };
    const playVideo = (video) => {
      if (reducedMotion.matches || document.hidden || video.dataset.tphrInView !== 'true') return;
      hydrate(video);
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(() => {});
      }
    };

    videos.forEach((video) => {
      video.setAttribute('data-tphr-video-banner-ready', 'true');
      video.muted = true;
      video.playsInline = true;

      if (reducedMotion.matches) return;

      if (!('IntersectionObserver' in window)) {
        video.dataset.tphrInView = 'true';
        playVideo(video);
        return;
      }

      const warmObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrate(video);
            warmObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '900px 0px', threshold: 0 });

      const playObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.18) {
            video.dataset.tphrInView = 'true';
            playVideo(video);
          } else if (!entry.isIntersecting) {
            video.dataset.tphrInView = 'false';
            video.pause();
          }
        });
      }, { threshold: [0, 0.18, 0.6] });

      warmObserver.observe(video);
      playObserver.observe(video);
    });

    reducedMotion.addEventListener('change', (event) => {
      videos.forEach((video) => {
        if (event.matches) {
          video.pause();
        } else {
          playVideo(video);
        }
      });
    });

    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => {
        if (document.hidden) {
          video.pause();
        } else {
          playVideo(video);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
